import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */
const controller = "/procedimento";

/**
 * Classe de gerenciamento de chamadas da API do Procedimento
 *
 * @class
 */
export default class ProcedimentoApi {
    /**
     * Instância da dependência da API (ofetch)
     */
    private api;

    /**
     * Cria uma nova instância da classe ProcedimentoApi.
     * @constructor
     * @param api - Instância da dependência da API (ofetch).
     */
    constructor(api: $Fetch) {
        this.api = api;
    }

    /**
   * @returns registro do procedimento
   */
    LerRegistro(codProcedimento: number) {

        return this.api<ApplicationModule[]>(`${controller}/LerRegistro`, {
            method: "GET",
            params: { codProcedimento }
        });
    }

}